import baseApi from 'store/slices/api/baseApi'

const artistsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getArtists: build.query({
            query: (query) => ({
                url: `artists/searchArtists?search=${query}`,
                method: 'GET',
            }),
        }),
    }),
    overrideExisting: false,
})

export const {useGetArtistsQuery} = artistsApi
export default artistsApi
